export const defaultSignatureFieldHeightPx = 60;
export const defaultSignatureFieldWidthPx = 256;
export const signatureFieldAspectRatio =
  defaultSignatureFieldWidthPx / defaultSignatureFieldHeightPx;
export const minSignatureFieldHeightPx = 16;
export const minSignatureFieldWidthPx = minSignatureFieldHeightPx * signatureFieldAspectRatio;
export const defaultInitialsFieldHeightPx = 60;
export const defaultInitialsFieldWidthPx = 150;
